import HTTP from "../HTTP";
import Jsona from "jsona";
import pgaHelper from "../helpers/paymentGatewayAccount";

const dataFormatter = new Jsona();

export default {
  async create(payload) {
    try {
      return await HTTP.normal.post(
        "/payment-gateway-accounts",
        pgaHelper.createPGARequestBody(payload)
      );
    } catch (e) {
      throw e.response.data;
    }
  },

  async createOnGateway(account_id) {
    try {
      await HTTP.withAccept.post(
        "/payment-gateway-accounts/create-on-gateway",
        pgaHelper.createOnGatewayRequestBody(account_id)
      );
    } catch (e) {
      throw e.response.data;
    }
  },

  async getTransfers(pgaId, numberPage, fieldSort, textSearch) {
    try {
      let search =
        textSearch.length > 3 ? `&filter[text_search]=${textSearch}` : "";
      let page = `&page[number]=${numberPage}`;
      let sort = "";
      let include =
        "include=payment_gateway_account.account.profile," +
        "channel.payment_gateway_account.account.profile";

      let transferRoute = `/payment-gateway-accounts/${pgaId}/transfers`;

      let results = await HTTP.normal.get(
        `${transferRoute}?${include}${search}${page}${sort}`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (error) {
      throw error.response.data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/paymentGatewayAccount.js